import React, { useRef, useState } from "react";
import { Paperclip, X, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import { parApi, parErr } from "@/lib/partnerApi";

/** Attach button: uploads each picked file and hands back the stored file records. */
export const AttachButton = ({ onAdd, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...(e.target.files || [])];
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    for (const f of files) {
      try { onAdd(await parApi.upload("/memos/files", f)); } catch (err) { toast.error(`${f.name}: ${parErr(err)}`); }
    }
    setBusy(false);
  };
  return (
    <>
      <input ref={ref} type="file" multiple hidden onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid}
        className="inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.16em] text-nex-muted hover:text-nex-gold transition-colors disabled:opacity-40">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Paperclip className="h-3 w-3" />} Attach
      </button>
    </>
  );
};

export const FileChips = ({ files, onRemove, testid }) => (files?.length ? (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {files.map((f) => (
      <span key={f.id} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border border-white/10 bg-white/[0.03] text-[11px] text-nex-silver">
        <button type="button" onClick={() => parApi.openFile(`/api/par/memos/files/${f.id}`).catch((e) => toast.error(parErr(e)))}
          data-testid={`memo-file-${f.id}`} className="inline-flex items-center gap-1 hover:text-nex-gold transition-colors">
          <FileText className="h-3 w-3" /> {f.name}
        </button>
        {onRemove && <button type="button" onClick={() => onRemove(f.id)} data-testid={`memo-file-remove-${f.id}`} className="text-nex-muted hover:text-red-300"><X className="h-3 w-3" /></button>}
      </span>
    ))}
  </div>
) : null);
